import { useTranslation } from 'react-i18next'

const values = [
  { icon: 'ri-heart-line', titleKey: 'about.value1Title', descKey: 'about.value1Desc' },
  { icon: 'ri-star-line', titleKey: 'about.value2Title', descKey: 'about.value2Desc' },
  { icon: 'ri-cpu-line', titleKey: 'about.value3Title', descKey: 'about.value3Desc' },
  { icon: 'ri-hand-heart-line', titleKey: 'about.value4Title', descKey: 'about.value4Desc' },
]

const stats = [
  { value: '5000万+', labelKey: 'about.statsUsers' },
  { value: '200万+', labelKey: 'about.statsVideos' },
  { value: '30+', labelKey: 'about.statsCountries' },
  { value: '500+', labelKey: 'about.statsPartners' },
]

const testimonials = [
  {
    name: '小王',
    role: '忠实用户',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20Chinese%20person%20portrait%20avatar%20illustration%20with%20warm%20orange%20accents%2C%20flat%20design%2C%20minimal%20cute%20style%2C%20circle%20frame&width=120&height=120&seq=testimonial-01&orientation=squarish',
    quote: '快猫短视频真的是我每天必刷的平台，内容特别丰富，推荐算法也很准，总是能推给我感兴趣的视频。用了半年多了，已经成为我生活中不可或缺的一部分。',
  },
  {
    name: '小美',
    role: '创作者',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20Chinese%20female%20portrait%20avatar%20illustration%20with%20coral%20pink%20accents%2C%20flat%20design%2C%20minimal%20cute%20style%2C%20circle%20frame&width=120&height=120&seq=testimonial-02&orientation=squarish',
    quote: '通过在快猫短视频发布内容，我收获了50万粉丝，也认识了很多志同道合的朋友。平台的创作者扶持计划让我的努力得到了实实在在的回报。',
  },
  {
    name: '老张',
    role: '资深用户',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20middle%20aged%20Chinese%20person%20portrait%20avatar%20illustration%20with%20warm%20amber%20tones%2C%20flat%20design%2C%20minimal%20style%2C%20circle%20frame&width=120&height=120&seq=testimonial-03&orientation=squarish',
    quote: '退休后通过快猫短视频学到了很多新东西，美食、旅行、养生，什么都有。现在每天不刷一会儿就觉得少了点什么，真的是老少皆宜的好平台。',
  },
]

export default function BrandSection() {
  const { t } = useTranslation('common')

  return (
    <>
      <section className="py-16 md:py-24 bg-background-50">
        <div className="mx-auto px-4 md:px-6 max-w-7xl">
          <div className="text-center mb-12 md:mb-16">
            <h1 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
              {t('about.title')}
            </h1>
            <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
              {t('about.subtitle')}
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
              <div className="lg:w-1/2">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20digital%20content%20studio%20with%20warm%20orange%20and%20coral%20accents%2C%20people%20collaborating%20on%20video%20content%2C%20bright%20airy%20open%20workspace%2C%20digital%20screens%20showing%20colorful%20content%2C%20energetic%20creative%20atmosphere%2C%20modern%20office%20interior%20photography&width=700&height=500&seq=about-brand&orientation=landscape"
                  alt="快猫短视频品牌"
                  className="rounded-2xl w-full object-cover"
                />
              </div>
              <div className="lg:w-1/2">
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">
                  {t('about.brandIntro')}
                </h2>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  {t('about.brandDesc')}
                </p>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {t('about.brandVision')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-primary-500">
        <div className="mx-auto px-4 md:px-6 max-w-7xl">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
            {stats.map((stat) => (
              <div key={stat.labelKey} className="text-center">
                <div className="font-heading text-3xl md:text-5xl text-background-50 mb-2">
                  {stat.value}
                </div>
                <div className="text-sm text-background-200/80">
                  {t(stat.labelKey)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-50">
        <div className="mx-auto px-4 md:px-6 max-w-7xl">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
              {t('about.valuesTitle')}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {values.map((val) => (
              <div key={val.icon} className="bg-background-100 rounded-2xl p-6 md:p-7 text-center hover:bg-background-200/70 transition-colors duration-300">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                  <i className={`${val.icon} text-primary-500 text-xl md:text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base text-foreground-950 mb-2">
                  {t(val.titleKey)}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  {t(val.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-100">
        <div className="mx-auto px-4 md:px-6 max-w-7xl">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
              {t('about.reputation')}
            </h2>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              {t('about.reputationSubtitle')}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {testimonials.map((tItem) => (
              <div key={tItem.name} className="bg-background-50 rounded-2xl p-6 md:p-7">
                <div className="flex items-center gap-3 mb-4">
                  <img src={tItem.avatar} alt={tItem.name} className="w-11 h-11 rounded-full object-cover" />
                  <div>
                    <div className="font-heading text-sm text-foreground-950">{tItem.name}</div>
                    <div className="text-xs text-foreground-500">{tItem.role}</div>
                  </div>
                </div>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  "{tItem.quote}"
                </p>
                <div className="flex items-center gap-0.5 mt-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}